/* eslint-disable */ import { applicationConfigComponent, assertBoolean, assertString, attributeSwitchComponent, boundingBoxComponent, canvasCustomEnvironmentComponent, childEntityRecipesComponent, composedOfComponent, fitRootPerspectiveCameraComponent, materialSwatchComponent, memoEval, priceComponent, sceneEntityAddFabComponent, sceneEntityPropertiesComponent, staticPerspectiveCameraComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { FloorTextureKey, HardwareMaterials } from '../model/index.js';
export const sceneComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withEntity('Scene').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(composedOfComponent, '$segments', true).withEntity('Scene').attach(memoEval((self)=>self.$segments.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(canvasCustomEnvironmentComponent, 'default', true).withEntity('Scene').attach(memoEval(()=>[], ()=>({
            name: 'AppEnvironment'
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'default', true).withEntity('Scene').attach(memoEval(()=>[], ()=>({
            layout: 'universal',
            ignoreSelectionInSidebar: true,
            initialGlobalUnit: 'inch',
            availableDimensions: [
                'inch'
            ],
            distanceDataUnit: 'inch',
            indicatorSwitch: false
        }))),
    attachComponent.withComponent(priceComponent, 'default', true).withEntity('Scene').attach(memoEval((self)=>[
            self.$price
        ], ($price)=>({
            price: $price,
            currency: 'USD'
        }))),
    attachComponent.withComponent(staticPerspectiveCameraComponent, 'default', true).withEntity('Scene').withGradualFilter({
        active: (self)=>self.$isEmptyScene
    }).attach(memoEval(()=>[], ()=>({
            priority: 2,
            distance: 120,
            minDistance: 120,
            maxDistance: 120,
            fov: 35,
            near: 20,
            far: 400,
            polarAngle: 1.5708,
            minPolarAngle: 1.5708,
            maxPolarAngle: 1.5708,
            azimuthAngle: 0,
            minAzimuthAngle: 0,
            maxAzimuthAngle: 0,
            lookAtX: 0,
            lookAtY: 30,
            lookAtZ: 0
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'default', true).withEntity('Scene').attach(memoEval((self)=>[
            self.$screenSizeAwareMaxDistance
        ], ($screenSizeAwareMaxDistance)=>({
            fitToBox: true,
            priority: 1,
            fov: 35,
            near: 20,
            far: 1500,
            minDistance: 60,
            maxDistance: $screenSizeAwareMaxDistance,
            polarAngle: 1.5708,
            maxPolarAngle: 1.5,
            minAzimuthAngle: -1.5708,
            maxAzimuthAngle: 1.5708,
            azimuthAngle: 0
        }))),
    attachComponent.withComponent(boundingBoxComponent, 'customRegion', true).withEntity('Scene').attach(memoEval((self)=>[
            self.$boundingBoxMinX,
            self.$boundingBoxMaxX,
            self.$boundingBoxMaxY
        ], ($boundingBoxMinX, $boundingBoxMaxX, $boundingBoxMaxY)=>({
            minX: $boundingBoxMinX,
            maxX: $boundingBoxMaxX,
            minY: 0,
            maxY: $boundingBoxMaxY,
            minZ: -1000,
            maxZ: 1000
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withEntity('Scene').attach(memoEval(()=>[], ()=>({
            offsetZ: -15
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addInitialBaseFab', true).withEntity('Scene').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$isEmptyScene
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 0,
            offsetY: 20,
            label: 'Add base or tall cabinet',
            instanceNames: [
                'baseCabinet',
                'tallCabinet',
                'countertop'
            ],
            skipMenuWhenOnlyOne: false,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addInitialWallFab', true).withEntity('Scene').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$isEmptyScene
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 0,
            offsetY: 70,
            label: 'Add wall cabinet',
            instanceNames: [
                'wallCabinet'
            ],
            skipMenuWhenOnlyOne: true,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'baseCabinet', true).withEntity('Scene').attach(memoEval((self)=>[
            self.$initialBaseCabinetRecipes
        ], ($initialBaseCabinetRecipes)=>({
            groupLabel: 'Base Cabinet',
            recipes: $initialBaseCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'tallCabinet', true).withEntity('Scene').attach(memoEval((self)=>[
            self.$initialTallCabinetRecipes
        ], ($initialTallCabinetRecipes)=>({
            groupLabel: 'Tall Cabinet',
            recipes: $initialTallCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'wallCabinet', true).withEntity('Scene').attach(memoEval((self)=>[
            self.$initialWallCabinetRecipes
        ], ($initialWallCabinetRecipes)=>({
            groupLabel: 'Wall Cabinet',
            recipes: $initialWallCabinetRecipes
        }))),
    attachComponent.withComponent(materialSwatchComponent, 'cabinetColor', true).withEntity('Scene').attach(memoEval((self)=>[
            self.cabinetColor,
            self.$colorSwatches
        ], (cabinetColor, $colorSwatches)=>({
            selectedSwatchKey: cabinetColor,
            swatches: $colorSwatches
        })), (state)=>{
        assertString(state.selectedSwatchKey);
        return {
            cabinetColor: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'wallCabinetColor', true).withEntity('Scene').attach(memoEval((self)=>[
            self.wallCabinetColor,
            self.$colorSwatches
        ], (wallCabinetColor, $colorSwatches)=>({
            selectedSwatchKey: wallCabinetColor,
            swatches: $colorSwatches
        })), (state)=>{
        assertString(state.selectedSwatchKey);
        return {
            wallCabinetColor: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'countertopColor', true).withEntity('Scene').attach(memoEval((self)=>[
            self.countertopColor,
            self.$countertopColorSwatches
        ], (countertopColor, $countertopColorSwatches)=>({
            selectedSwatchKey: countertopColor,
            swatches: $countertopColorSwatches
        })), (state)=>{
        assertString(state.selectedSwatchKey);
        return {
            countertopColor: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'hardwareMaterial', true).withEntity('Scene').attach(memoEval((self)=>[
            self.hardwareMaterial,
            self.$hardwareMaterialSwatches
        ], (hardwareMaterial, $hardwareMaterialSwatches)=>({
            selectedSwatchKey: hardwareMaterial,
            swatches: $hardwareMaterialSwatches
        })), (state)=>{
        HardwareMaterials.assert(state.selectedSwatchKey);
        return {
            hardwareMaterial: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'floorTexture', true).withEntity('Scene').attach(memoEval((self)=>[
            self.floorTexture,
            self.$floorTextureSwatches
        ], (floorTexture, $floorTextureSwatches)=>({
            selectedSwatchKey: floorTexture,
            swatches: $floorTextureSwatches
        })), (state)=>{
        FloorTextureKey.assert(state.selectedSwatchKey);
        return {
            floorTexture: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(attributeSwitchComponent, 'includeCountertop', true).withEntity('Scene').attach(memoEval((self)=>[
            self.includeCountertop
        ], (includeCountertop)=>({
            value: includeCountertop
        })), (state)=>{
        assertBoolean(state.value);
        return {
            includeCountertop: state.value
        };
    }),
    attachComponent.withComponent(attributeSwitchComponent, 'hasDifferentWallCabinetColor', true).withEntity('Scene').attach(memoEval((self)=>[
            self.hasDifferentWallCabinetColor
        ], (hasDifferentWallCabinetColor)=>({
            value: hasDifferentWallCabinetColor
        })), (state)=>{
        assertBoolean(state.value);
        return {
            hasDifferentWallCabinetColor: state.value
        };
    }),
    attachComponent.withComponent(attributeSwitchComponent, 'showPrices', true).withEntity('Scene').attach(memoEval((self)=>[
            self.showPrices
        ], (showPrices)=>({
            value: showPrices
        })), (state)=>{
        assertBoolean(state.value);
        return {
            showPrices: state.value
        };
    })
];

//# sourceMappingURL=scene.js.map